module.exports = __webpack_public_path__ + "media/banner.b6aab8fe.mp4";